<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute, RouterView } from 'vue-router'
import AppLayout from '@/layout/AppLayout.vue'
import BackendDownOverlay from '@/components/BackendDownOverlay.vue'
import BuildInfoFooter from '@/components/common/BuildInfoFooter.vue'
import NuovaVersioneBanner from '@/components/common/NuovaVersioneBanner.vue'
import { startHeartbeat } from '@/composables/useBackendStatus'
import { startControlloVersione } from '@/composables/useNuovaVersione'

const route = useRoute()
const isPublicRoute = computed(() => route.meta.publicLayout === true)

// Heartbeat ogni 15s: rileva il backend down anche senza request utente
onMounted(() => {
  startHeartbeat()
  startControlloVersione()
})
</script>

<template>
  <template v-if="isPublicRoute">
    <RouterView />
  </template>
  <AppLayout v-else />

  <!-- Overlay globale: appare quando il backend non risponde -->
  <BackendDownOverlay />

  <!-- Avviso: c'è una versione nuova del portale (il ricaricamento lo sceglie l'utente) -->
  <NuovaVersioneBanner />

  <!-- Footer di debug: versione FE/BE attiva (dev sempre, prod solo super-admin) -->
  <BuildInfoFooter />
</template>
